import { Cart as CtCart, LineItem as CtLineItem, ProductVariant } from '@commercetools/platform-sdk';
import { convertCentAmount, mapMoney, mapPriceFromArray } from '@utils';
import { Cart, LineItem, LineItemProductVariant } from '@services/cart';
import { PriceWithDiscount } from '@services';
import { PRODUCT_TYPE } from '@constants';


export const mapFullVariant = (variant: ProductVariant): LineItemProductVariant => ({
  id: variant.id,
  imageUrl: variant.images?.[0]?.url ?? '',
  attributes: (variant.attributes ?? []).map(attr => ({
    name: attr.name,
    label: attr.name,
    value: String(attr.value)
  }))
});


const mapFullLineItemTotalPrice = (item: CtLineItem): PriceWithDiscount => {
  const hasCartDiscount = !!item.discountedPricePerQuantity?.length;

  return hasCartDiscount ? {
    currencyCode: item.totalPrice.currencyCode,
    value: convertCentAmount((item.price.discounted?.value?.centAmount ?? item.price.value?.centAmount) * item.quantity),
    discountedValue: convertCentAmount(item.totalPrice.centAmount)
  } : mapMoney(item.totalPrice);
};

export const mapFullLineItem = (item: CtLineItem): LineItem => ({
  id: item.id,
  productId: item.productId,
  name: item.name['en-US'],
  quantity: item.quantity,
  price: mapPriceFromArray([ item.price ]),
  totalPrice: mapFullLineItemTotalPrice(item),
  variant: mapFullVariant(item.variant),
  productType: { name: item.productType.obj?.name as PRODUCT_TYPE ?? PRODUCT_TYPE.CLOTHING }
});

export const mapFullCart = (cart: CtCart): Cart => ({
  id: cart.id,
  anonymousId: cart.anonymousId,
  version: cart.version,
  totalLineItemQuantity: cart.totalLineItemQuantity ?? 0,
  totalPrice: mapMoney(cart.totalPrice),
  lineItems: cart.lineItems.map(mapFullLineItem),
  shippingPrice: cart.shippingInfo
    ? mapPriceFromArray([ { value: cart.shippingInfo.price, discounted: cart.shippingInfo.discountedPrice } ])
    : undefined,
  //TODO: Expand discount code references
  discountCodes: []
});
